import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SessionService
{
    public static get(key: string): string {
        return sessionStorage.getItem(key);
    }

    public static set(key: string, value: string) {
        return sessionStorage.setItem(key, value);
    }

    //noinspection JSUnusedGlobalSymbols
    public static destroy(key: string) {
        return sessionStorage.removeItem(key);
    }
}
